import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert as MaterialAlert, AlertTitle } from '@material-ui/lab';
import { makeStyles, darken } from '@material-ui/core';
import { useTheme } from '../../themes';
import { CheckCircleIcon, ExclamationCircleIcon, ExclamationTriangleIcon, InfoIcon } from '../Icon';
import { withDefaultPropsAndStyles } from '../utils';
const useStyles = makeStyles(({ typography }) => ({
    root: {
        borderRadius: 3,
        display: 'flex',
        fontSize: typography.pxToRem(16),
        justifyContent: (props) => props.align,
    },
    alertTitle: {
        textAlign: (props) => props.align,
    },
}));
export const LiquidityAlertBanner = (_a) => {
    var { children, align = 'center', severity = 'info', icon, alertTitle, variant } = _a, rest = __rest(_a, ["children", "align", "severity", "icon", "alertTitle", "variant"]);
    const classes = useStyles({ align });
    const { alertTitle: alertTitleClass, root } = classes;
    const { palette } = useTheme();
    const getIconColor = (color) => {
        if (variant === 'standard') {
            return color;
        }
        return 'inherit';
    };
    const iconMapping = {
        success: _jsx(CheckCircleIcon, { fontSize: "inherit", style: { color: getIconColor(darken(palette.success.main, 0.6)) } }, void 0),
        error: (_jsx(ExclamationCircleIcon, { fontSize: "inherit", style: { color: getIconColor(darken(palette.error.main, 0.6)) } }, void 0)),
        warning: (_jsx(ExclamationTriangleIcon, { fontSize: "inherit", style: { color: getIconColor(darken(palette.warning.main, 0.6)) } }, void 0)),
        info: _jsx(InfoIcon, { fontSize: "inherit", style: { color: getIconColor(darken(palette.info.main, 0.6)) } }, void 0),
    };
    return (_jsxs(MaterialAlert, Object.assign({ severity: severity, classes: {
            root,
        }, iconMapping: iconMapping, variant: variant }, rest, { children: [alertTitle && (_jsx(AlertTitle, Object.assign({ className: alertTitleClass, color: "inherit" }, { children: alertTitle }), void 0)),
            children] }), void 0));
};
export const AlertBanner = withDefaultPropsAndStyles('AlertBanner', LiquidityAlertBanner, {
    styles: ({ palette }) => ({
        // NOTE: these empty styles need to exist here in order for the
        // theme-specific overrides to be applied.
        root: {},
        filledSuccess: {},
        filledInfo: {},
        filledWarning: {},
        filledError: {},
        standardSuccess: {
            border: 'solid 1px',
            borderColor: darken(palette.success.main, 0.6),
        },
        standardInfo: {
            border: 'solid 1px',
            borderColor: darken(palette.info.main, 0.6),
        },
        standardWarning: {
            border: 'solid 1px',
            borderColor: darken(palette.warning.main, 0.6),
        },
        standardError: {
            border: 'solid 1px',
            borderColor: darken(palette.error.main, 0.6),
        },
    }),
});
//# sourceMappingURL=AlertBanner.js.map